import { localize } from 'vee-validate';

localize({
  en: {
    messages: {
      required: 'This field is required',
      number: "This field must be a number",
      email: "A valid email address is required",
      double: "This field must be a number"
    }
  }
});
